import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeProps } from 'antd';
import styled, { css } from 'styled-components';

export interface ClaimBadgeProps {
  status: string;
}

const borderedCss = css`
  border-width: 1px;
  border-style: solid;
  line-height: 1.5;
`;

interface StyledBadgeProps extends BadgeProps {
  claimStatus?: string;
}

const StyledBadge = styled(Badge)<StyledBadgeProps>`
  user-select: none;
    ${({ claimStatus }) => {
      switch (claimStatus) {
        case 'SUBMITTED':
          return `
            > .ant-badge-count {
              ${borderedCss}
              background-color: var(--white);
              border-color: var(--success-color);
              color: var(--success-color);
            }
          `;
        case 'IN_PROGRESS':
          return `
            > .ant-badge-count {
              background-color: var(--success-color);
            }
          `;
        case 'DECLINED':
          return `
            > .ant-badge-count {
              background-color: var(--declined-color);
              color: var(--white);
            }
          `;
        case 'COMPLETED':
          return `
            > .ant-badge-count {
              ${borderedCss}
              background-color: var(--white);
              border-color: var(--complete-color);
              color: var(--complete-color);
            }
          `;
        case 'NEED_ACTION':
          return `
            > .ant-badge-count {
              background-color: var(--warning-color);
            }
          `;
        default:
          return;
      }
    }}
  }
`;

const ClaimBadge = ({ status }: ClaimBadgeProps): JSX.Element => {
  const { t } = useTranslation();
  return <StyledBadge claimStatus={status} count={t(`enum.claimStatus.${status}`)} />;
};

export default ClaimBadge;
